

window.addEventListener("load", function () {

    // var myAudio = document.getElementById("myAudio");
    // var isPlaying = false;
    // var checkedBody = false;
    // //var myElementToCheckIfClicksAreInsideOf = document.querySelector('#scrollContent');
    // document.body.addEventListener('click', function (event) {
    //     if (!checkedBody) {
    //         if (!isPlaying) {
    //             isPlaying = true;
    //             checkedBody = true;
    //             $(".btn-music").removeClass('mute');
    //             myAudio.play();
    //         }
    //     }
    // });
    // $(".btn-music").on("click", function (e) {
    //     if (!isPlaying) {
    //         console.log("on");
    //         isPlaying = true;
    //         $(this).removeClass('mute');
    //         myAudio.play();
    //     } else {
    //         console.log("off");
    //         isPlaying = false;
    //         $(this).addClass('mute');
    //         myAudio.pause();
    //     }
    // });
  


  
  


});
